<template>
  <div id="_2025_1">
    <div id="Call-for-Nominations">
      <h3>
        <strong class="home-h"
        >The fifth training course on geographical analysis models in China
        </strong>
      </h3>
      <hr />
      <p>
        The 5th training course on geographic analysis models in China was
        successfully held from August 9th to 16th, 2025. It was mainly organized
        by Nanjing Normal University, the Geographical Society of China (GSC),
        China Society of Natural Resources (CSNR), China Association for
        Geospatial Information Society (CAGIS), Chinese National Committee of
        International Society for Digital Earth (ISDE). Our Modeling Geographical
        Systems Commission (MGSC) of the International Geographical Union (IGU)
        was also one of the co-organizers to support the training course.
      </p>
      <p>
        The course focused on the theme of “Geospatial Intelligent Analysis”.
        It featured detailed presentations on four advanced models:
        <ul>
          <li>Urban vision models developed by Prof. Fan Zhang's team (Peking University)</li>
          <li>Urban growth models developed by Prof. Yimin Chen's team (Sun Yat-sen University)</li>
          <li>Urban representation, monitoring, and simulation models developed by Prof. Yao Yao's team (China University of Geosciences)</li>
          <li>Intelligent analysis models for multisource remote sensing data developed by Prof. Min Wang's team (Nanjing Normal University)</li>
        </ul>
      </p>
      <p>
        The success of this training course can promote the construction of the
        geographic model ecosystem in China and the open and sustainable
        geographic model community. It can also facilitate model reusing,
        knowledge sharing, and collaborative geographic research.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: '_2025_1'
};
</script>
<style scoped lang="less">
#_2025_1 {
  height: fit-content;
  font-size: 1.2rem;
  line-height: 2rem;
  width: 65%;
  margin: 0 auto;
  position: relative;
  word-spacing: 0.3rem;
  margin-top: 2.2rem;
  line-height: 2rem;
  text-align: justify;
  height: 55rem;
}

h3 {
  color: #1a80b6;
  font-size: 1.3rem;
  font-weight: 1000;
}

h4 {
  margin-top: 0.9rem;
  margin-bottom: 0.9rem;
}

.home-date {
  font-weight: bold;
  color: grey;
}

a {
  text-decoration: none;
}

.pic {
  // display: table-cell;
  text-align: center;
  height: 128px;
  width: 128px;
  overflow: hidden;
}
.flex {
  display: flex;
  // justify-content: center;
}
</style>
